// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__3huPI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOARatioUplinkTrend/styles.scss
// module id = 2270
// module chunks = 1